/* eslint-disable @typescript-eslint/no-explicit-any */
import { BeekLogo, Input } from 'beek-design-system';
import { Button } from '@beek/design-system';
import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import styled from 'styled-components';

import AccountMenu from './AccountMenu';
import useCheckSession from 'src/utils/useCheckSession';

const NavBarContainer = styled.nav`
  z-index: 1;
  display: flex;
  position: sticky;
  width: 100%;
  height: 4.5rem;
  top: 0;
  padding-inline: 1rem;
  gap: 1rem;
  background-color: rgba(255, 255, 255, 1);
  border-bottom: 0.0313rem solid var(--gray-15);
  align-items: center;
  justify-content: space-between;
  box-shadow: 0rem 0rem 1.25rem rgba(0, 0, 0, 0.1);
`;

const IconContainer = styled.div`
  flex-shrink: 0;
`;

const NavBar = (): JSX.Element => {
  const [isSearchClicked, setIsSearchClicked] = useState(false);

  const t = useTranslations('articles');
  const session = useCheckSession();

  useEffect(() => {
    setIsSearchClicked(true);
  }, []);

  const DynamicInput: any = dynamic(
    (): any => import('../Algolia/AlgoliaInput'),
    {
      ssr: false,
      loading: () => (
        <Input placeholder={`${t('nav.placeholder')}`} icon="search" />
      ),
    }
  );
  return (
    <NavBarContainer>
      <BeekLogo variant="small" />
      {isSearchClicked ? (
        <DynamicInput
          type="not_landing"
          placeholder={`${t('nav.placeholder')}`}
          noResultsText={`${t('nav.no_results')}`}
        />
      ) : (
        <Input placeholder={`${t('nav.placeholder')}`} icon="search" />
      )}
      <IconContainer>
        {session ? (
          <AccountMenu />
        ) : (
          <Link href="/login" passHref>
            <Button>{t('nav.login')}</Button>
          </Link>
        )}
      </IconContainer>
    </NavBarContainer>
  );
};

export default NavBar;
